import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export class BuyFeatureFinishedUIAct extends SyncUIActDecorator {
    public execute(): void {
        if (slotStore.logic_buyFeatureIsProgressStarted.value) {
            this.emitter.emit('UI.buyFeature.bet.finished');
        }
        this.onExecuted?.();
    }

    getName(): string {
        return 'BuyFeatureFinishedUIAct';
    }
}